import type { FaireProductEntity } from "../../entity_types/product";

export const p_7cmrcr22c8: FaireProductEntity = {
  token: "p_7cmrcr22c8",
  type: "product",
  name: "Skin Salve – All-Purpose Herbal Healing Balm",
  brandToken: "b_129dsr49u5",
  brandName: "Taylor Made Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/61a15713e544e6dc70063375dbd3ad9a33741aad21e4b82345b402f95cae3db2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a31a9bc4171c424385a41ed08f5b18964e08f4b91d1281e252cfb505f2da958c.png",
    "https://cdn.faire.com/fastly/97193c8a58c1fe78aa22c35065d77f961abd3380188bccf904c4594d74a5c8bf.png",
    "https://cdn.faire.com/fastly/1b749e3ccbf5daa86f2d73e1caffd8587eeec86146aa99e314b30f3c8dd9fc18.png",
    "https://cdn.faire.com/fastly/c56be1b1a67bc9045650251f7298038d5c06dff04a8eacbb0a4b8ccdc8978322.png",
  ],
  priceDollars: 11.5,
  description:
    "Best-selling herbal skin salve for 25+ years. All-purpose healing balm for burns, bites, diaper rash, cracked skin & more. Gentle, organic & effective.\n\nOur best-selling Skin Salve has been trusted for over 25 years as an all-purpose herbal healing balm for the whole family. Originally created to soothe my daughter’s severe diaper rash, this gentle yet effective formula has become a customer favorite for decades.\n\nPacked with organic botanicals and nourishing butters, this versatile salve provides natural relief for:\n\nDiaper rash & irritated skin\nBurns, bee stings & bug bites\nDry, cracked heels & hands\nStretch marks & tattoo aftercare\nEveryday cuts, scrapes & rough patches\n\nHandcrafted with calendula, comfrey, plantain, and St. John’s Wort infused in sunflower and olive oil, plus shea butter, cocoa butter, and lavender essential oil, it delivers soothing comfort and deep moisture with every application.\n\n✔ Family-friendly, safe & effective\n✔ All-purpose healing balm for skin relief\n✔ Cruelty-free, made in the USA\n✔ Free from parabens, glycol, phthalates, dyes, fragrances & gluten\n\nOnce you try it, you’ll see why it’s been our bestseller for over two decades—a must-have in every medicine cabinet, diaper bag, or travel kit.",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:38.655Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
